// extracted by mini-css-extract-plugin
export var avatar = "_ow-3";
export var avatarContainer = "_ow-2";
export var avatarSpacer = "_ow-5";
export var avatarSpacerContainer = "_ow-4";
export var avatarStackContainer = "_ow-1";
export var bubble = "_ow-0";
export var remainderBubble = "_ow-6";